import { LOCALE_TYPE } from 'src/types/locale';

export const convertLocaleForGoogleMap = (locale: string | undefined): string => {
  // Based on https://developers.google.com/maps/faq#languagesupport
  switch (locale) {
    case LOCALE_TYPE.JA:
      return 'ja';
    case LOCALE_TYPE.HK:
      return 'zh-HK';
    case LOCALE_TYPE.EN:
      return 'en';
    case LOCALE_TYPE.TW:
    default:
      return 'zh-TW';
  }
};
